require('./angular-messages');
module.exports = 'ngMessages';



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/~/angular-messages/index.js
 ** module id = 206
 ** module chunks = 0
 **/